export default {"src":"/_next/static/media/rocket.bcae1380.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};